<template>

    <div class="empty-spoum-area" v-show="showEmptySpoumArea">

        <p class="text-lSemibold">{{$t('no_spams_identified_title')}}</p>

        <p class="text-baseRegular color__moon mt__8">{{$t('no_spams_identified_desc')}}</p>

    </div>

</template>

<script>
import Vuex from 'vuex'

import ENUM from '@/assets/ENUM'

export default {

    name: 'empty-spoum-area',

    props: {
        subscriptions: {
            type: Array,
            default: () => []
        },

        category: {
            type: String,
            default: ''
        }
    },

    computed: {

        ...Vuex.mapGetters([
            'noMailboxSelectedButNewslettersWaiting'
        ]),

        showEmptySpoumArea() {
            return this.category === ENUM.NEWSLETTERS.CATEGORIES.SPAMS && this.subscriptions.length === 0 && !this.noMailboxSelectedButNewslettersWaiting
        },

        ENUM() {
            return ENUM
        }
    }

}
</script>

<style lang="scss" scoped>

.empty-spoum-area {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  padding: 16px;
  background-color: $timberwolf;
}

</style>
